import { useFormViewTemplate, LineMessageForm } from '../../../components';

import { DefaultView } from './DefaultView';

interface FormViewProps {
  id?: string;
  onSubmit: () => void;
}

export const FormView = ({ id, onSubmit }: FormViewProps) => {
  const TemplateView = useFormViewTemplate();

  return (
    <LineMessageForm.Form onSubmit={onSubmit} id={id} noValidate>
      {TemplateView ? (
        <div className="flex flex-col gap-y-6">
          <TemplateView />
        </div>
      ) : (
        <DefaultView />
      )}
    </LineMessageForm.Form>
  );
};
